import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core/';
import ComplexDescription from '../../complexDescription/.mixins/complexDescription';

export default function MultiSelectCheckbox(props) {
    const { itensModal, handleChange, SecondaryDescription } = props;

    return (
        <>
            {itensModal.map((element, i) => (
                <FormControlLabel
                    value={element.id}
                    label={    
                    <ComplexDescription 
                        element={element}
                        SecondaryDescription={SecondaryDescription}
                    />}
                    key={i}
                    control={
                        <Checkbox
                            checked={element.checked}
                            onChange={handleChange}
                        />
                    }
                />
            ))}
        </>
    );
}
